export const ElemSchema = () => ({
  title: "Element",
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['stadt','name','titel', 'funktion',  'telefon', 'mail'],
    },
  ],

  properties: {  
    name: {
      title: 'Name',
      type: 'string',
    },
    titel: {
      title: 'Titel',
      type: 'string',
    },
    funktion: {
      title: 'Funktion',
      type: 'string',
    },
    stadt: {
      title: 'Stadt',
      type: 'string',
    },
    telefon: {
      title: 'Telefon',
      type: 'string',
    },
    mail: {
      title: 'E-Mail',
      type: 'mail',
    },
  },
  required: [],
});

export const EditSchema = (intl) => ({
  title: "Schema",
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [],
    },
    {
      id: 'content',
      title: "Kontakt hinzu",
      fields: ['elems'],
    },
  ],

  properties: {
    elems: {
      title: "Elements",
      schema: ElemSchema(intl),
      widget: 'object_list',
    },
  },
  required: [],
});
